<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <router-link :to="{ name: 'inventario-conteo' }" style="color: blueviolet;">
            <i class="fa fa-arrow-left"></i>
            Listado de Conteos
          </router-link>
          <router-link :to="{ name: 'inventario-conteo-agrupado' }" style="float: right; color: blueviolet;">
            Conteos Agrupados
            <i class="fa fa-arrow-right"></i>
          </router-link>
          <br><br>
          <div class="element-wrapper">
            <div class="element-box">
              <div class="btn-group" style="float: right;">
                <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                  data-toggle="dropdown" type="button">
                  <i class="fa fa-cogs"></i>
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button type="button" class="dropdown-item" @click="finalizarConteo()" href="#"
                    :disabled="current.fecha_finalizacion !== null || current.estado == '9'">
                    Finalizar Conteo &nbsp;
                    <i class="fa fa-check"></i>
                  </button>
                  <button type="button" class="dropdown-item" @click="crearIncidencia()" href="#"
                    :disabled="current.fecha_finalizacion == null || current.tipo !== 'P' || current.conteo_agrupado !== null">
                    Crear Incidencia &nbsp;
                    <i class="fab fa-gitlab espaciado-icon"></i>
                  </button>
                  <button type="button" class="dropdown-item" @click="anularConteo()" href="#"
                    :disabled="current.estado == '9' || current.conteo_agrupado != null || tieneDetalle">
                    Anular Conteo &nbsp;
                    <i class="fa fa-ban"></i>
                  </button>
                </div>
              </div>
              <br>
              <form>
                <h5 class="form-header ml-2">
                  <h5 v-if="current.tipo != 'R'">
                    Conteo #{{ current.numero }}&nbsp; | &nbsp;
                  </h5>
                  <h5 v-else>
                    Revisión #{{ current.numero }}&nbsp; | &nbsp;
                  </h5>
                  <div class="badge" :class="{
                    'badge-success': !current.fecha_finalizacion && current.estado != '9',
                    'badge-warning': current.fecha_finalizacion && current.estado != '9',
                    'badge-danger': current.estado == '9',
                  }">
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado == '9'">Anulado</span>
                    <span v-else-if="!current.fecha_finalizacion">En Proceso</span>
                    <span v-else>Finalizado</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <!-- <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button> -->
                      &nbsp;
                    </div>
                  </div>
                </h5>
                <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                  current.errors.detail }}</small>
                <ul class="nav nav-tabs d-md-none mb-3">
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: tabMovil === 'contado' }" href="#"
                      @click.prevent="tabMovil = 'contado'">
                      Contado
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: tabMovil === 'datos' }" href="#"
                      @click.prevent="tabMovil = 'datos'">
                      Datos del Conteo
                    </a>
                  </li>
                </ul>
                <div class="row col-12">
                  <div class="col-sm-4 col-md-4" :class="{ 'conteo-oculto-movil': tabMovil !== 'datos' }">
                    <TiendaSelectComponent :disabled="true" :current="current" />
                  </div>
                  <div class="col-sm-4 mt-2" :class="{ 'conteo-oculto-movil': tabMovil !== 'datos' }">
                    <div class="form-group">
                      <UsuariosSelectComponent :disabled="true" :current="current" />
                    </div>
                  </div>
                  <div class="col-sm-4" :class="{ 'conteo-oculto-movil': tabMovil !== 'datos' }">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Tipo Conteo</label>
                      <select class="form-control" id="exampleFormControlSelect1" v-model="current.tipo"
                        :disabled="true">
                        <option value="N">Normal</option>
                        <option value="A">Conteo Agrupado</option>
                        <option value="B">Conteo ABC</option>
                        <option value="P">Próximos a Vencer</option>
                        <option value="R">Revisión 80/20</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4" v-if="current.conteo_agrupado_obj"
                    :class="{ 'conteo-oculto-movil': tabMovil !== 'datos' }">
                    <div class="form-group">
                      <label>Conteo Agrupado</label>
                      <input class="form-control" type="text" :disabled="true"
                        :value="'#' + current.conteo_agrupado_obj.numero + ' (' + current.conteo_agrupado_obj.identificador + ')'" />
                      <router-link
                        :to="{ name: 'inventario-conteo-agrupado-editar', params: { id: current.conteo_agrupado_obj.id } }"
                        style="color: blueviolet;">
                        Ver conteo agrupado
                      </router-link>
                    </div>
                  </div>
                  <div class="col-sm-6" :class="{ 'conteo-oculto-movil': tabMovil !== 'datos' }">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger': current.errors && current.errors.fecha,
                      }">Fecha Creación</label>
                      <input v-model="current.fecha_creacion" class="form-control" placeholder="Fecha"
                        :disabled="true" type="text" />
                      <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                        current.errors.fecha[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-6" :class="{ 'conteo-oculto-movil': tabMovil !== 'datos' }">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger': current.errors && current.errors.fecha,
                      }">Fecha Finalización</label>
                      <input v-model="current.fecha_finalizacion" class="form-control" placeholder="Pendiente"
                        :disabled="true" type="text" />
                      <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                        current.errors.fecha[0] }}</small>
                    </div>
                  </div>
                  <button v-if="current.tipo != 'R'" type="button" @click="showModalAddDetail()" class="btn btn-success btn-md btn-block mx-2"
                  :class="{ 'conteo-oculto-movil': tabMovil !== 'contado' }"
                  :disabled="current.fecha_finalizacion || current.estado == '9'">
                    Contar Producto
                  </button>
                  <button v-if="current.tipo == 'R'" type="button" @click="showModalAddDetail()" class="btn btn-success btn-md btn-block mx-2"
                  :class="{ 'conteo-oculto-movil': tabMovil !== 'contado' }"
                  :disabled="current.fecha_finalizacion || current.estado == '9'">
                    Revisar Producto
                </button>
                <br />
                <div class="form-buttons-w"></div>

                </div>
                
              </form>
            </div>

            <!-- TABLAS DE DATOS -->
            <div class="element-box pb-5" :class="{ 'conteo-oculto-movil': tabMovil !== 'contado' }">
              <div class="col-12 text-left py-2">
                <h5>Información Detallada</h5>
              </div>
              <div v-if="current.tipo != 'R' && current.conteod_set.length > 0 && current.conteod_set">
                <div 
                  v-for="(detail, index) in current.conteod_set" 
                  v-bind:key="index"
                >
                  <div v-if="detail.detalles">
                    <div class="borderY py-4"
                    v-bind:style="detail.detalles == detalle
                      ? 'background-color: #d8d8d8;'
                      : 'background-color: #FFFFFF;'
                    " @click="OpenSlideOpt(detail.detalles)"
                    >
                      <div class="card-body">
                        <div class="row px-3">
                          <div class="col-6 d-flex align-items-start">
                            <span class="conteo-orden mr-3">{{ detail.orden }}</span>
                            <div>
                              <h5 class="card-title">
                                {{ detail.producto_lote.producto }}
                              </h5>
                              <span>
                                ({{ detail.producto_lote.id }})
                              </span>
                              <p class="card-text mb-1 font-weight-bold">
                                {{ detail.detalles[0].producto.nombre }}
                              </p>
                              <small class="text-muted d-block">
                                <i class="fa fa-clock mr-1"></i>
                                Último conteo: {{ detail.ultima_fecha | moment("DD/MM/YYYY HH:mm:ss") }}
                              </small>
                            </div>
                          </div>
                          <div class="col-6 d-flex justify-content-end align-items-center text-right">
                            <div class="row">
                              <div class="col-12">
                                <h6 class="text-muted">
                                  <b>Conteo Total:</b>
                                </h6>
                                <h4>
                                  {{ 
                                    detail.cantidad_total.toLocaleString("en-GB")
                                  }}
                                </h4>
                              </div>
                              <div class="col-12">
                                <h6 class="text-muted">
                                  <b>Teórico Total:</b>
                                </h6>
                                <h4>
                                  {{ 
                                    detail.teorico_total.toLocaleString("en-GB")
                                  }}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="detalle == detail.detalles" >
                      <ConteoStockInventarioTabla
                        @refresh="refreshCurrent" 
                        @id-anular-detalle="AnularDetalle" 
                        :dataTabla="detail.detalles" 
                        :tipo="current.tipo" 
                        :bloqueado="!!current.fecha_finalizacion || current.estado == '9'"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="current.conteod_set.length == 0">
                  <p class="card-title text-muted text-center py-4">
                    Aún no hay productos asignados a este conteo
                  </p>
                </div>
              </div>
              <div v-if="current.tipo == 'R' && current.conteod_set.length > 0" >
                <ConteoInventarioDetalleTableComponent 
                  @refresh="refreshCurrent" 
                  @id-anular-detalle="AnularDetalle" 
                  :dataTabla="current" 
                  :tipo="current.tipo" 
                  :bloqueado="!!current.fecha_finalizacion || current.estado == '9'"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    

    <div aria-hidden="true" class="modal fade" id="modalDetalle" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Conteo de Producto &nbsp;<i class="os-icon os-icon-package"></i></h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <h6 class="font-weight-bold text-success">
                  {{ producto.producto_obj.sku }}
                </h6>
                <h6 class="font-weight-bold text-success">
                  {{ producto.producto_obj.nombre }}
                </h6>
              </div>
              <div class="col-sm-12">
                <label>Producto Barra</label>
                <input type="text" class="form-control" v-model="currentDetalle.barra_producto"
                  ref="inputBarra" :class="{ 'is-invalid': errorBarra }" @focus="$event.target.select()"
                  v-on:keyup.enter="setSelected()" />
                <small v-if="errorBarra" class="form-text text-danger font-weight-bold">
                  {{ errorBarra }}
                </small>
                <small v-if="currentDetalle.errors && currentDetalle.errors.barra_producto"
                  class="form-text text-danger">
                  Barra: {{ currentDetalle.errors.barra_producto }}
                </small>
                <div>
                  <br>
                  <button :disabled="!currentDetalle.barra_producto" class="btn btn-md btn-success btn-block" @click="setSelected()">
                    Buscar <i class="os-icon os-icon-external-link"></i>
                  </button>
                  <br>
                </div>
              </div>



              
              <div v-if="currentDetalle.posicion" class="col-sm-12 mb-2">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: tabDetalle === 'conteo' }" href="#"
                      @click.prevent="tabDetalle = 'conteo'">
                      Conteo
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: tabDetalle === 'ubicacion', 'text-danger': tieneErroresUbicacion }"
                      href="#" @click.prevent="tabDetalle = 'ubicacion'">
                      Lote y Ubicación
                    </a>
                  </li>
                </ul>
              </div>

              <!-- PESTAÑA CONTEO -->
              <div v-if="currentDetalle.posicion" v-show="tabDetalle === 'conteo'" class="col-12">
                <div class="row">
                  <div class="col-sm-12 mb-2">
                    <small class="text-muted">
                      Lote: {{ loteSeleccionadoTexto }} &nbsp;|&nbsp; Posición: {{ posicionSeleccionadaTexto }}
                    </small>
                  </div>
                  <div v-if="currentDetalle.posicion && current.tipo === 'P'" class="col-sm-12 mb-1">
                    Fecha Vencimiento:
                    <input type="date" class="form-control" v-model="currentDetalle.fecha_vencimiento" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.fecha_vencimiento"
                      class="form-text text-danger">
                      {{ currentDetalle.errors.fecha_vencimiento }}
                    </small>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-12">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger':
                          currentDetalle.errors &&
                          currentDetalle.errors.cantidad,
                      }">Cantidad en Unidades</label>
                      <input v-model="currentDetalle.cantidad" class="form-control" placeholder="Cantidad" type="text"
                        ref="inputCantidad" inputmode="decimal" @focus="$event.target.select()"
                        style="text-align: center; font-size: 200%" v-bind:class="{
                          'is-invalid':
                            currentDetalle.errors && currentDetalle.errors.cantidad,
                        }" v-on:keyup.enter="agregaDetalle" />
                      <small v-if="
                        currentDetalle.errors && currentDetalle.errors.cantidad
                      " class="form-text text-danger">{{ currentDetalle.errors.cantidad }}</small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- PESTAÑA LOTE Y UBICACION: se llena automaticamente con los valores por defecto, editable si se necesita -->
              <div v-if="currentDetalle.posicion" v-show="tabDetalle === 'ubicacion'" class="col-12">
                <div class="row">
                  <div v-if="currentDetalle.posicion" class="col-sm-12 mb-1">
                    <span> Lotes:</span>
                    <select v-model="currentDetalle.producto_lote" class="form-control">
                      <option v-for="detalle in currentDetalle.productolote_set" :value="detalle.id"
                        v-bind:key="detalle.id">
                        Lote: {{ detalle.codigo_lote }}
                      </option>
                    </select>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                    Bodega:
                    <select v-model="busqueda_posicion.bodega_id" class="form-control" @change="changeBodega"
                      autofocus="autofocus">
                      <option v-for="detalle in bodegas" :value="detalle.id" v-bind:key="detalle.bodega">
                        {{ detalle.bodega }} - {{ detalle.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                    Seccion:
                    <select v-model="busqueda_posicion.seccion_id" class="form-control" @change="changeSeccion"
                      autofocus="autofocus">
                      <option v-for="detalle in secciones" :value="detalle.id" v-bind:key="detalle.seccion">
                        {{ detalle.seccion }} - {{ detalle.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                    Rack:
                    <select v-model="busqueda_posicion.rack_id" class="form-control" @change="changeRack"
                      autofocus="autofocus">
                      <option v-for="detalle in racks" :value="detalle.id" v-bind:key="detalle.rack">
                        {{ detalle.rack }} - {{ detalle.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                    Nivel:
                    <select v-model="busqueda_posicion.nivel_id" class="form-control" @change="changeNivel">
                      <option v-for="detalle in niveles" :value="detalle.id" v-bind:key="detalle.nivel">
                        {{ detalle.nivel }} - {{ detalle.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                    Posicion:
                    <i style="color: red;">*</i>
                    <select v-model="currentDetalle.posicion" class="form-control">
                      <!-- .posicion -->
                      <option v-for="detalle in posiciones" :value="detalle.posicion_id" v-bind:key="detalle.id">
                        {{ detalle.codigo_barra}}
                      </option>
                    </select>
                    <small v-if="currentDetalle.errors && currentDetalle.errors.posicion" class="form-text text-danger">{{
                      currentDetalle.errors.posicion }}</small>
                  </div>
                  <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                    Nombre de Posicion seleccionada:
                    <i style="color: red;"></i>
                    <select v-model="currentDetalle.posicion" class="form-control select-no-arrow" disabled>
                      <option v-for="detalle in posiciones" :value="detalle.posicion_id" v-bind:key="detalle.id">
                        {{ detalle.nombre}}
                      </option>
                    </select>
                    <small v-if="currentDetalle.errors && currentDetalle.errors.posicion" class="form-text text-danger">{{
                      currentDetalle.errors.posicion }}</small>
                  </div>
                  <div v-if="currentDetalle.posicion && current.tipo !== 'P'" class="col-sm-6 mb-1">
                    Fecha Vencimiento:
                    <input type="date" class="form-control" v-model="currentDetalle.fecha_vencimiento" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.fecha_vencimiento"
                      class="form-text text-danger">
                      {{ currentDetalle.errors.fecha_vencimiento }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="currentDetalle.posicion">
            <div class="row col-sm col-12">
              <div class="col-6">
                <button class="btn btn-primary btn-block" @click="agregaDetalle" type="button">
                  Contar <i class="os-icon os-icon-check-circle"></i>
                </button>
              </div>
              <div class="col-6">
                <button class="btn btn-danger btn-block" @click="cancelar()" data-dismiss="modal" type="button"
                  ref="cerrarModal">
                  Cancelar <i class="os-icon os-icon-cancel-circle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div aria-hidden="true" class="modal fade" id="modalDetalleRev8020" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Revisión de Producto 80/20&nbsp;<i class="os-icon os-icon-package"></i></h5>
            <button v-if="!producto.producto_obj" aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div v-if="producto.producto_obj.sku"  class="col-12">
                <h6 class="font-weight-bold text-success">
                  {{ producto.producto_obj.sku }}
                </h6>
                <h6 class="font-weight-bold text-success">
                  {{ producto.producto_obj.nombre }}
                </h6>
              </div>
              <div class="col-sm-12">
                <label>Producto Barra</label>
                <input type="text" class="form-control" v-model="currentDetalle.barra_producto"
                  ref="inputBarraRev" :class="{ 'is-invalid': errorBarra }" @focus="$event.target.select()"
                  v-on:keyup.enter="setSelected()" />
                <small v-if="errorBarra" class="form-text text-danger font-weight-bold">
                  {{ errorBarra }}
                </small>
                <small v-if="currentDetalle.errors && currentDetalle.errors.barra_producto"
                  class="form-text text-danger">
                  {{ currentDetalle.errors.barra_producto }}
                </small>
                <div>
                  <br>
                  <button :disabled="!currentDetalle.barra_producto" class="btn btn-md btn-success btn-block" @click="setSelected()">
                    Buscar <i class="os-icon os-icon-external-link"></i>
                  </button>
                  <br>
                </div>
              </div>
              <div class="col-sm-12" v-if="producto.producto_obj.sku">
                <hr>
                <!--div v-if="currentDetalle.posicion" class="col-sm-6 mb-1"-->
                <div v-if="currentDetalle.posicion" >  
                  <label> Lotes:</label><br>
                  <div class="input-group">
                    <select v-model="currentDetalle.producto_lote" class="form-control" >
                      <option v-for="detalle in currentDetalle.productolote_set" :value="detalle.id"
                        v-bind:key="detalle.id">
                        Lote: {{ detalle.codigo_lote }}
                      </option>
                    </select>                     
                      <button class="btn btn-success ml-1 ">
                        <i class="fas fa-plus"></i>
                        Lote nuevo
                      </button>   
                  </div>
                    
                  <div class="mt-2 w-100">
                    Fecha Vencimiento:
                    <input type="date" class="form-control" v-model="currentDetalle.fecha_vencimiento" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.fecha_vencimiento"
                      class="form-text text-danger">
                      {{ currentDetalle.errors.fecha_vencimiento }}
                    </small>
                  </div>    
                  

                  <div class="mt-2 w-100">
                    <span>Causal:</span>
                    <select v-model="causalSelected" class="form-control input-group-lg">
                      <option value="" selected disabled>
                        - Causal a Asignar -
                      </option>
                      <option v-for="(detalle, index) in listado_causales" :key="index" :value="index">
                        {{ detalle.nombre }}
                      </option>
                    </select>
                  </div>
                  <div v-if="listado_motivos_causales.length > 0" class="mt-2">
                    <span>Detalle del Causal:</span>
                    <select v-model="causalMotivoSelected" class="form-control input-group-lg">
                      <option value="" selected>
                        - Detalle del Causal -
                      </option>
                      <option v-for="(detalle, index) in listado_motivos_causales" :key="index" :value="detalle.id">
                        {{ detalle.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <hr>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="producto.producto_obj">
            <div class="row col-sm col-12">
              <div class="col-6">
                <button :disabled="currentDetalle.causal == ''" class="btn btn-primary btn-block" @click="agregaDetalle" type="button">
                  Validar <i class="os-icon os-icon-check-circle"></i>
                </button>
              </div>
              <div class="col-6">
                <button class="btn btn-danger btn-block" @click="cancelar()" data-dismiss="modal" type="button"
                  ref="cerrarModal">
                  Cancelar <i class="os-icon os-icon-cancel-circle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import ConteoInventarioDetalleTableComponent from "@/components/inventario/conteo_inventario/ConteoInventarioDetalleTableComponent";
import ConteoStockInventarioTabla from "@/components/inventario/conteo_inventario/ConteoStockInventarioTabla";

export default {
components: {
  TiendaSelectComponent,
  UsuariosSelectComponent,
  ConteoInventarioDetalleTableComponent,
  ProductoSelectComponent,
  ConteoStockInventarioTabla
},
data() {
  return {
    current: {
      id: null,
      estado_str: null,
      tienda: "",
      fecha: "",
      estado: "A",
      errors: [],
      conteod_set: []
    },
    causalSelected: "",
    causalMotivoSelected: "",
    listado_causales: [],
    listado_motivos_causales: [],
    productos: [],
    posiciones: [],
    options: [],
    producto_lote: [],
    producto: {
      producto_obj: {
        sku: ""
      },
    },
    bodegas: [],
    secciones: [],
    racks: [],
    niveles: [],
    busqueda_posicion: {
      bodega_id: null,
      seccion_id: null,
      rack_id: null,
      posicion_id: null,
    },
    currentDetalle: {
      cantidad: 0,
      posicion: "",
      producto: "",
      fecha_vencimiento: "",
      codigo_lote: 0,
      productolote_set: [],
      errors: [],
      causal: "",
    },
    detalle: [],
    tabDetalle: "conteo",
    tieneDetalle: false,
    tabMovil: "contado",
    errorBarra: ""
  };
},
computed: {
  ...mapGetters({
    tiendas: "catalogos/tiendas",
  }),
  loteSeleccionadoTexto() {
    const lote = (this.currentDetalle.productolote_set || []).find(
      (item) => item.id == this.currentDetalle.producto_lote
    );
    return lote ? lote.codigo_lote : "-";
  },
  posicionSeleccionadaTexto() {
    const posicion = (this.posiciones || []).find(
      (item) => item.posicion_id == this.currentDetalle.posicion
    );
    return posicion ? posicion.codigo_barra + " - " + posicion.nombre : "-";
  },
  tieneErroresUbicacion() {
    const errors = this.currentDetalle.errors;
    if (!errors) return false;
    return !!(
      errors.posicion ||
      errors.producto_lote ||
      (errors.fecha_vencimiento && this.current.tipo !== "P")
    );
  },
},
watch: {
  causalSelected(newValue) {
    this.causalMotivoSelected = "";
    if (typeof newValue != "string") {
      let idCausal = this.listado_causales[newValue].id;
      this.currentDetalle.causal = idCausal;
      this.listado_motivos_causales = this.listado_causales[newValue].motivos;
    } else {
      this.currentDetalle.causal = "";
      this.listado_motivos_causales = [];
    }
  },
  causalMotivoSelected(newValue, oldValue) {
    if (this.listado_motivos_causales.length > 0) this.currentDetalle.causal = newValue;
    if (newValue == "") this.currentDetalle.causal = this.listado_causales[this.causalSelected].id;
  },
},
mounted() {
  let self = this;
  CommonService.fecha_actual().then((res) => {
    self.current.fecha = res.data.fecha_actual;
    self.formatoFecha();
  });
  this.$store.dispatch("catalogos/llenar_tiendas", {
    activa: true,
    quitar_paginacion: true,
  });
  if (this.$route.params.id) {
    self.refreshCurrent();
  }
},
methods: {
  formatoFecha() {
    let self = this;
    self.current.fecha = self.current.fecha.replace(/\//g, "-");
  },
  refreshCurrent() {
    let self = this;
    DynamicService.getById(
      "inv",
      "conteo-inventario",
      this.$route.params.id
    ).then((response) => {
      self.tieneDetalle = (response.data.conteod_set || []).filter(
        (item) => item.estado != "9"
      ).length > 0;
      self.current = response.data;
      self.getListadoCausales();
      if (self.current.tipo != "R") {
        self.sumarCantidadesContadas(self.current.conteod_set)
      } else {
        self.current.resumen = self.current.resumen.filter(item => item.estado == "A");
        // El primero de la lista (el mas reciente) lleva el total de revisiones,
        // igual que el numero de orden de escaneo de los demas tipos de conteo.
        const activos = self.current.conteod_set.filter(item => item.estado == "A").sort((a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion));
        activos.forEach((item, index) => {
          item.orden = activos.length - index;
        });
        self.current.conteod_set = activos;
        
      }
      self.current.fecha_creacion = moment(
        self.current.fecha_creacion
      ).format("DD/MM/YYYY HH:mm:ss A");
      if (self.current.fecha_finalizacion) {
        self.current.fecha_finalizacion = moment(
          self.current.fecha_finalizacion
        ).format("DD/MM/YYYY HH:mm:ss A");
      }
    });
  },
  async sumarCantidadesContadas(objData){
    let self = this;
    console.log("OBJ DATA: ",objData)
      if (self.current.tipo !== "R") {
        // Fecha del ultimo escaneo por lote, incluyendo lineas anuladas, para
        // que un producto conserve su lugar aunque se anule su ultimo escaneo
        const ultimoEscaneo = {};
        objData.forEach((item) => {
          const id = item.producto_lote.id;
          if (!ultimoEscaneo[id] || new Date(item.fecha_creacion) > new Date(ultimoEscaneo[id])) {
            ultimoEscaneo[id] = item.fecha_creacion;
          }
        });
        const agrupado = await objData.reduce((acc, item) => {
        if (item.estado === "9") return acc;
        const loteId = item.producto_lote.id;
        if (!acc[loteId]) {
          acc[loteId] = {
            ...item,
            producto_lote: item.producto_lote,
            cantidad_total: 0,
            teorico_total: 0,
            detalles: [],
            ultima_fecha: ultimoEscaneo[loteId]
          };
        }
        acc[loteId].cantidad_total += Number(item.cantidad_contada);
        acc[loteId].teorico_total = Number(item.existencia_al_asignar);
        acc[loteId].detalles.push(item);
        return acc;
      }, {});
      //self.current.conteod_set = Object.values(agrupado);
      // Muestra primero el producto contado mas recientemente (si se vuelve
      // a escanear, sube al inicio). El numero es solo un contador: el primero
      // de la lista lleva el total de productos escaneados.
      let ordenados = Object.values(agrupado).sort((a, b) => {
        return new Date(b.ultima_fecha) - new Date(a.ultima_fecha);
      });
      ordenados.forEach((grupo, index) => {
        grupo.orden = ordenados.length - index;
      });
      self.current.conteod_set = ordenados;
      console.log("El Current Nuevo: ", self.current.conteod_set)
    }
  },
  /**
   * Método que setea la data del evento, cuando se abre el panel 
   * inferior en donde se muestran los botónes o informacion detallada 
   * de los eventos en la agenda
   */
  OpenSlideOpt(det) {
    let self = this;
    if (self.detalle == det) {
      self.detalle = "";
      return;
    }
    self.detalle = det;
  },


  limpiarData() {
    let self = this;
    self.producto = {
      producto_obj: "",
    }
    self.currentDetalle = {
      cantidad: 0,
      posicion: "",
      producto: "",
      fecha_vencimiento: "",
      codigo_lote: 0,
      productolote_set: [],
      errors: [],
      causal: "",
    }
    self.causalMotivoSelected = "";
    self.causalSelected = "";
    self.tabDetalle = "conteo";
  },
  getListadoCausales() {
    let self = this;
    DynamicService.getActionList(
      "inv", 
      "listado-causales",
      "obtener_listado_causales"
    ).then((res) => {
      self.listado_causales = res.data;
    });
  },
  showModalAddDetail() {
    let self = this;
    ProductosService.fetch({
      page: 1,
      activo: true,
      permitir_compra: true,
    }).then((res) => {
      self.productos = res.data.results;
    });
    PosicionesService.fetch({
      page: 1,
      tienda: self.current.tienda,
      activo: true,
    }).then((res) => {
      self.posiciones = res.data.results;
    });
    self.getListadoCausales();
    self.tabDetalle = "conteo";
    self.errorBarra = "";
    if (self.current.tipo != "R") {
      $("#modalDetalle").modal();
    } else {
      $("#modalDetalleRev8020").modal();
    }
  },

  agregaDetalle() {
    let self = this;
    let det = Object.assign({}, self.currentDetalle);
    let tieneDetalleCausal
    if(self.causalSelected) {
      tieneDetalleCausal =  self.listado_causales[self.causalSelected].motivos.length >0
    }
    
    let motivoSeleccionado = self.causalMotivoSelected != ""


    if (!det.fecha_vencimiento) {
      det.fecha_vencimiento = null;
    } 

    if(!tieneDetalleCausal || (tieneDetalleCausal && motivoSeleccionado)){      
      DynamicService.postAction(
      "inv",
      "conteo-inventario",
      self.current.id,
      "contar",
      det
      )
      .then((response) => {
        Notifications.toast.success(
          "Conteo guardado",
          "Puede escanear el siguiente producto",
          { position: "topCenter", timeout: 2000 }
        );
        self.refreshCurrent();
        self.refreshDetalleDefault();
        self.$refs.cerrarModal.click();
        self.limpiarData();
      })
      .catch((error) => {
        if (!error || !error.response) {
          console.error(error);
          Notifications.toast.error(
            "Error al registrar",
            "Error inesperado. Revise el detalle antes de volver a contar.",
            { position: "topCenter" }
          );
          self.refreshCurrent();
          return;
        }
        self.currentDetalle.errors = error.response.data;
        Notifications.toast.error(
          "Error al registrar",
          String(self.currentDetalle.errors.conteo || "Revise los datos ingresados"),
          { position: "topCenter" }
        );
      });
    }
    else if(tieneDetalleCausal && !motivoSeleccionado){      
      Notifications.toast.error(
        "Elegir detalle de causal",
        "Debe seleccionar un detalle de causal",
        { position: "topCenter" }
      );
    }     
  },

  agregaDetalle_80_20() {
    let self = this;
    let det = Object.assign({}, self.currentDetalle);
    if (!det.fecha_vencimiento) {
      det.fecha_vencimiento = null;
    }
   
    DynamicService.postAction(
      "inv",
      "conteo-inventario",
      self.current.id,
      "contar",
      det
    )
      .then((response) => {
        Notifications.toast.success(
          "Conteo guardado",
          "Puede escanear el siguiente producto",
          { position: "topCenter", timeout: 2000 }
        );
        self.refreshCurrent();
        self.refreshDetalleDefault();
        self.$refs.cerrarModal.click();
        self.limpiarData();
      })
      .catch((error) => {
        if (!error || !error.response) {
          console.error(error);
          Notifications.toast.error(
            "Error al registrar",
            "Error inesperado. Revise el detalle antes de volver a contar.",
            { position: "topCenter" }
          );
          self.refreshCurrent();
          return;
        }
        self.currentDetalle.errors = error.response.data;
        Notifications.toast.error(
          "Error al registrar",
          "Completa los campos obligatorios marcados con * rojo",
          { position: "topCenter" }
        );
      });
  },
  finalizarConteo() {
    let self = this;
    Notifications.alert.confirm(
      "Conteo de Inventario",
      "Desea Finalizar la transacción?",
      "Si Finalizar",
      function () {
        DynamicService.postAction(
          "inv",
          "conteo-inventario",
          self.current.id,
          "finalizar"
        )
          .then((response) => {
            Notifications.alert.success(
              "Conteo de Inventario",
              "Se ha Finalizado la transaccion."
            );
            self.refreshCurrent();
          })
          .catch((error) => {
            Notifications.alert.error(
              "Finalizar Transaccion",
              error.response.data.detail
            );
          });
      }
    );
  },
  anularConteo() {
    let self = this;
    Notifications.alert.confirm(
      "Anular Conteo",
      "Desea anular el conteo? Esta accion no se puede revertir.",
      "Si Anular",
      function () {
        DynamicService.postAction(
          "inv",
          "conteo-inventario",
          self.current.id,
          "anular"
        )
          .then((response) => {
            Notifications.alert.success(
              "Anular Conteo",
              "Se ha anulado el conteo."
            );
            self.refreshCurrent();
          })
          .catch((error) => {
            Notifications.alert.error(
              "Anular Conteo",
              error.response.data.detail
            );
          });
      }
    );
  },
  crearIncidencia() {
    let self = this;
    Notifications.alert.confirm(
      "Crear Incidencia en GitLab",
      "Desea crear una incidencia relacionada al conteo?",
      "Si Crear",
      function () {
        DynamicService.postAction(
          "inv",
          "conteo-inventario",
          self.current.id,
          "incidencia"
        )
          .then((response) => {
            Notifications.alert.success(
              "Incidencia Creada",
              "Se redireccionará a GitLab para dar seguimiento"
            );
            self.refreshCurrent();
          })
          .catch((error) => {
            Notifications.alert.error(
              "No se pudo crear Incidencia",
              error.response.data.detail
            );
          });
      }
    );
  },
  refreshDetalleDefault() {
    let self = this;
    (self.busqueda_posicion = {
      bodega_id: null,
      seccion_id: null,
      rack_id: null,
      posicion_id: null,
    }),
      (self.currentDetalle = {
        barra_producto: "",
        cantidad: 0,
        producto_lote: "",
        fecha_vencimiento: "",
        posicion: "",
        errors: [],
      });
    self.producto.producto_obj.sku = "";
    self.producto.producto_obj.nombre = "";
    self.tabDetalle = "conteo";
  },
  refreshBodegas() {
    let self = this;
    DynamicService.fetch("cat", "tienda-bodega", {
      tienda: self.current.tienda,
      quitar_paginacion: true,
    }).then((res) => {
      self.bodegas = res.data;
      console.log(self.bodegas[0].id)
      if (self.busqueda_posicion.bodega_id == null) {
        self.busqueda_posicion.bodega_id = self.bodegas[0].id;
        this.refreshSecciones();
      }
    });
  },
  changeBodega() {
    this.refreshSecciones();
  },
  changeSeccion() {
    this.refreshRacks();
  },
  changeRack() {
    this.refreshNiveles();
  },
  changeNivel() {
    this.refreshPosiciones();
  },
  refreshSecciones() {
    let self = this;
    DynamicService.fetch("cat", "tienda-seccion", {
      tienda: self.current.tienda,
      bodega: self.busqueda_posicion.bodega_id,
      quitar_paginacion: true,
    }).then((res) => {
      self.secciones = res.data;
      if (self.busqueda_posicion.seccion_id == null) {
        self.busqueda_posicion.seccion_id = self.secciones[0].id;
        this.refreshRacks();
      }
    });
  },
  refreshPosiciones() {
    let self = this;
    let params = {
      page: 1,
      tienda: self.current.tienda,
      quitar_paginacion: true,
    };
    if (self.busqueda_posicion.bodega_id) {
      params.bodega_id = self.busqueda_posicion.bodega_id;
    }
    if (self.busqueda_posicion.seccion_id) {
      params.seccion_id = self.busqueda_posicion.seccion_id;
    }
    if (self.busqueda_posicion.rack_id) {
      params.rack_id = self.busqueda_posicion.rack_id;
    }
    if (self.busqueda_posicion.nivel_id) {
      params.nivel_id = self.busqueda_posicion.nivel_id;
    }
    PosicionesService.fetch(params).then((res) => {
      self.posiciones = res.data;
      if (self.busqueda_posicion.posicion_id == null) {
        // DEBE SER POSICION_ID NO ID DE POSICION
        self.currentDetalle.posicion = self.posiciones[0].posicion_id;
        console.log(self.posiciones)
      }
      self.enfocarCantidad();
    });
  },
  refreshRacks() {
    let self = this;
    DynamicService.fetch("cat", "tienda-rack", {
      tienda: self.current.tienda,
      seccion: self.busqueda_posicion.seccion_id,
      quitar_paginacion: true,
    }).then((res) => {
      self.racks = res.data;
      if (self.busqueda_posicion.rack_id == null) {
        self.busqueda_posicion.rack_id = self.racks[0].id;
        this.refreshNiveles();
      }
    });
  },
  refreshNiveles() {
    let self = this;
    DynamicService.fetch("cat", "tienda-nivel", {
      tienda: self.current.tienda,
      rack: self.busqueda_posicion.rack_id,
      quitar_paginacion: true,
    }).then((res) => {
      self.niveles = res.data;
      if (self.busqueda_posicion.nivel_id == null) {
        self.busqueda_posicion.nivel_id = self.niveles[0].id;
        this.refreshPosiciones();
      }
    });
  },
  setSelected(value) {
    let self = this;
    let barra = String(self.currentDetalle.barra_producto || "").trim();
    self.errorBarra = "";
    DynamicService.postAction(
      "inv",
      "conteo-inventario",
      self.current.id,
      "validar_producto",
      { barra_producto: barra }
    )
      .then(() => {
        self.buscarProductoValidado();
      })
      .catch((error) => {
        let mensaje;
        if (!error || !error.response) {
          console.error(error);
          mensaje = "No se pudo validar la barra " + barra + ". Revise la conexion.";
        } else {
          let data = error.response.data || {};
          if (data.conteo) {
            mensaje = data.conteo + " (barra " + barra + ")";
          } else if (data.detail === "El código ingresado no existe") {
            mensaje = "La barra " + barra + " no fue encontrada";
          } else {
            mensaje = String(data.detail || "No se pudo validar la barra " + barra);
          }
        }
        self.errorBarra = mensaje;
        Notifications.toast.error(
          "Producto no disponible para conteo",
          mensaje,
          { position: "topCenter" }
        );
        self.producto = { producto_obj: { sku: "", nombre: "" } };
        self.currentDetalle.posicion = "";
        self.currentDetalle.productolote_set = [];
        self.currentDetalle.producto_lote = "";
        self.$nextTick(() => {
          self.seleccionarBarra();
        });
      });
  },
  seleccionarBarra() {
    let input = this.current.tipo == "R" ? this.$refs.inputBarraRev : this.$refs.inputBarra;
    if (input) {
      input.focus();
      input.select();
    }
  },
  buscarProductoValidado() {
    DynamicService.fetch("cat", "producto-barra", {
      barra: this.currentDetalle.barra_producto,
    }).then((response) => {
      this.producto = response.data.results[0];
      if (!this.producto) {
        Notifications.alert.error(
          "Buscar Producto",
          "Ningún Producto Encontrado"
        );
      }
      if (this.producto.producto_obj.sku) {
        ProductosService.getById(this.producto.producto_obj.sku).then((res) => {
          this.currentDetalle.productolote_set = res.data.productolote_set;
          this.currentDetalle.producto_lote = res.data.productolote_set[0].id;
          this.tabDetalle = "conteo";
          this.enfocarCantidad();
        });
      }
    });
    this.refreshBodegas();
  },
  enfocarCantidad() {
    this.$nextTick(() => {
      if (this.$refs.inputCantidad) {
        this.$refs.inputCantidad.focus();
      }
    });
  },
  cancelar() {
    let self = this;
    self.$refs.cerrarModal.click();
    self.refreshCurrent();
    self.refreshDetalleDefault();
    self.limpiarData();
  },
  AnularDetalle(id){
    let self = this;
    Notifications.alert.confirm(
      "Anular Detalle",
      "Desea anular el detalle?",
      "Si Anular",
    function(){
      DynamicService.postAction(
      "inv",
      "conteo-inventario",
      self.current.id,
      "anular_detalle",
      {id: id}
    )
    .then((response) => {
      Notifications.toast.success(
        "Detalle anulado",
        "Se ha anulado el detalle",
        { position: "topCenter", timeout: 2000 }
      );
      self.refreshCurrent();
    })
    .catch((error) => {
      let data = (error && error.response && error.response.data) || {};
      if (!error || !error.response) {
        console.error(error);
      }
      Notifications.toast.error(
        "Error al anular detalle",
        String(data.detail || "Error inesperado. Revise el detalle."),
        { position: "topCenter" }
      );
      self.refreshCurrent();
    });
    }    
    )
    
  }
},
};
</script>
<style lang="css">
.espaciado-icon {
  margin-right: -12px;
}
.borderY {
  transition: all .2s;
  border-top: solid 1px #DDD;
  border-bottom: solid 1px #DDD;
}
.borderY:hover {
  transition: all .2s;
  background-color: #f1f1f1!important;
}
.conteo-orden {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 2.2rem;
  height: 2.2rem;
  padding: 0 .4rem;
  border-radius: 1.1rem;
  background-color: #e9ecef;
  color: #333;
  font-weight: bold;
  font-size: 1rem;
}
@media (max-width: 767.98px) {
  .conteo-oculto-movil {
    display: none !important;
  }
}
</style>